import React from 'react'
import context from '@/context'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import { DataLoader } from '@/components/dataLoader'
import LoadingIndicator from '@/components/LoadingIndicator'
import { Table } from 'reactstrap'
import { Link } from 'react-router-dom'
import kebabCase from 'lodash/kebabCase'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { Button } from '@/components/button'
import { useLocalization } from '@/hooks/localization'

const ChangeItem = ({ item, task }) => {
  const linkTo = `/${kebabCase(item.scope)}/~${item.id}`
  const { localize } = useLocalization()
  const openErrorDialog = () => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.validationErrors,
      errorInfo: item.validationErrors
    }))
  }
  const openAlertDialog = () => {
    getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.alert,
      title: localize('Tasks:MinMergeCompaniesExceededTitle'),
      content: localize('Tasks:MinMergeCompaniesExceededContent')
    }))
  }
  const isValidTaskType = task.type.code === 'AssignMergedCompanies' || task.type.code === 'ApproveWorkDone'
  const changeItem = task.changeRequest.items[0]
  const isTaskValid = isValidTaskType && task && task.changeRequest && task.changeRequest.items && task.changeRequest.items[0]
  let modifiedDataParsed = null
  if (isTaskValid) {
    if (typeof changeItem.modifiedData === 'string') {
      try {
        modifiedDataParsed = JSON.parse(changeItem.modifiedData)
      } catch (error) {
        console.error('Failed to parse JSON:', error)
        modifiedDataParsed = {}
      }
    } else {
      modifiedDataParsed = changeItem.modifiedData
    }
  }

  let mergedCompaniesParsed = []
  if (modifiedDataParsed && modifiedDataParsed.mergedCompanies) {
    mergedCompaniesParsed = modifiedDataParsed.mergedCompanies
  }

  let minimumInstitutions = 0
  if (modifiedDataParsed) {
    const classMinimumInstitutions = modifiedDataParsed.class ? modifiedDataParsed.class.minimumInstitutions : 0
    minimumInstitutions = modifiedDataParsed.minimumInstitutionsOverride || classMinimumInstitutions || 0
  }

  const crossedMinCompaniesNumber = mergedCompaniesParsed.length > minimumInstitutions

  return (
    <tr>
      <td><Link to={linkTo}>{item.name}</Link></td>
      <td><Link to={linkTo}>(<Resx name={item.targetId ? 'Tasks.ChangeItemModification' : 'Tasks.ChangeItemInsert'} />)</Link></td>
      <td className='validation-status'><Link to={linkTo}>{item.validationErrorsCount > 0
        ? <Button onClick={openErrorDialog} className='red align-items-center inline-flex'><Icon name='error' />&nbsp;{item.validationErrorsCount}x</Button>
        : <Icon name='check green' />
      }</Link></td>
      {crossedMinCompaniesNumber &&
      <td className='validation-status'><Button onClick={openAlertDialog} className='orange align-items-center inline-flex'><Icon name='error' />&nbsp;</Button>
      </td>}
    </tr>
  )
}
const ChangeRequestItems = ({ changeRequestId, task }) => {
  if (!changeRequestId) { return null }
  return (
    <DataLoader
      dataSource={() => context.api.changeRequestService.getChangeItems(changeRequestId, {})}
      render={x =>
        x.loading
          ? <LoadingIndicator />
          : <Table borderless className='table-change-items'>
            <tbody>
              {x.data.data.map((item, index) => <ChangeItem key={index} item={item} task={task} />)}
            </tbody>
          </Table>
      } />
  )
}

export {
  ChangeRequestItems
}



// WEBPACK FOOTER //
// ./src/internal-app/components/tasks/changeRequestItems.js